// extracted by mini-css-extract-plugin
export default {"painel":"styles_painel__SURUE","card":"styles_card__LU5SY"};